/**
 * Common query key factory for consistent key generation
 */
export const queryKeys = {
    countries: ['admin/selects/countries'] as const,
    projects: ['projectsSelectList'] as const,
    users: (params?: Record<string, unknown>) => ['users', params] as const,
    screens: (params?: Record<string, unknown>) => ['screens', params] as const,
    links: (params?: Record<string, unknown>) => ['links', params] as const,
} as const;
